import { Box, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { FC, useState } from "react";
import { PersonItemModel } from "../../../types/person-item.type";
import StyledWrapper from "./person-item.styles";
import PersonPopover from "../person-popover/person-popover.component";

type Props = {
  imageSrc: string;
  personItem: PersonItemModel;
  isMobile?: boolean;
  integratedType: "speakers" | "organizer";
  open?: boolean;
  onToggle?: () => void;
};

const PersonItem: FC<Props> = ({
  imageSrc,
  personItem,
  isMobile,
  integratedType,
  open,
  onToggle,
}) => {
  const isControlled = open !== undefined;
  const [internalOpen, setInternalOpen] = useState(false);
  const isOpen = isControlled ? open : internalOpen;

  const handleToggle = () => {
    if (!personItem.hasDetails) return;
    if (isControlled) {
      onToggle?.();
    } else {
      setInternalOpen((prev) => !prev);
    }
  };

  const handleClose = () => {
    if (isControlled) {
      if (open) onToggle?.();
    } else {
      setInternalOpen(false);
    }
  };

  return (
    <StyledWrapper>
      <Box
        className={`person-image ${isOpen ? "active-popover" : ""}`}
        sx={{ backgroundImage: `url(${imageSrc})` }}
        onClick={handleToggle}
      >
        {personItem.hasDetails && (
          <>
            <Box className="person-overlay-box" />
            <KeyboardArrowDownIcon className="person-arrow" />
          </>
        )}
      </Box>
      <Box className="person-content-holder">
        <Box className="person-name-holder">
          <Typography className={`person-firstname ${integratedType}`} variant="mainBlack">
            {personItem.firstName}
          </Typography>
          {personItem.lastName && (
            <Typography className={`person-lastname ${integratedType}`} variant="mainBlack">
              {personItem.lastName}
            </Typography>
          )}
        </Box>
        <Typography className={`person-role ${integratedType}`} variant="main">
          {personItem.role}
        </Typography>
      </Box>
      <PersonPopover
        open={isOpen}
        description={personItem.description}
        firstName={personItem.firstName}
        lastName={personItem.lastName}
        role={personItem.role}
        isMobile={isMobile}
        handleClose={handleClose}
        integratedType={integratedType}
      />
    </StyledWrapper>
  );
};

export default PersonItem;
